import { Check, TrendingUp } from "lucide-react";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { RetirementContext } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import type { InspirationToneNoteContent } from "web_myplann/Inspiration/Types/InspirationTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";
import { formatPercent } from "web_myplann/Shared/Utils/numberFormatters";

const R = Resources.Inspiration.Retirement;

export const mapRetirementPaceFeedback = (
	context: RetirementContext,
): InspirationToneNoteContent => {
	const percent = formatPercent(context.shownCoverage, 0);

	if (context.planCoversGoal)
		return {
			color: "green",
			icon: Check,
			text:
				context.shownCoverage >= 100 ? R.paceCoveredFull : R.paceCoveredPartial,
			values: { percent },
		};

	return {
		color: "orange",
		icon: TrendingUp,
		text: R.paceShortfall,
		values: {
			percent,
			required: formatInspirationMoney(context.selectedRequiredContribution),
			gap: formatInspirationMoney(context.contributionShortfall),
		},
	};
};
